import { Alert } from '@/model/alert';
import { createStore } from 'vuex';

export default createStore({
	state: {
		alerts: [] as Alert[]
	},
	getters: {
		alerts(state) {
			return state.alerts;
		}
	},
	mutations: {
		appendAlert(state, alert: Alert) {
			if (state.alerts.length < 1) {
				state.alerts.push(alert);
			}
		},
		dismissAlert(state, id: number) {
			state.alerts = state.alerts.filter((alert) => alert.id !== id);
		},
		clearAlert(state) {
			state.alerts = [];
		}
	},
	actions: {
		alert({ commit }, alert: Alert) {
			const id = Math.floor(Math.random() * 10000);
			alert.id = id;
			commit('appendAlert', alert);
			setTimeout(() => commit('dismissAlert', id), alert.timeout || 3000);
		},
		clearAlert({ commit }) {
			commit('clearAlert');
		}
	},
	modules: {}
});
